import { Navigate, Outlet } from 'react-router-dom';
import { useLiveConversation } from '@/hooks/useLiveConversation';

/**
 * Route guard for the TRFer's live-conversation pages (#2566): Unreads
 * (`/trfer/threads`), a thread, and the mobile handoff sheet. While the
 * feature is dormant, a deep link lands on
 * Today instead of a page nothing leads to. It waits for the first answer
 * from the server rather than bouncing a TRFer on a slow poll.
 */
export function LiveConversationGate({ fallback }: { fallback: string }) {
  const { enabled, ready } = useLiveConversation();
  if (!ready) return null;
  return enabled ? <Outlet /> : <Navigate to={fallback} replace />;
}
